import voter from "./voter";
import nonvoter from "./nonvoter";
import Masters from "./Masters";
import development from "./development";
import schememaster from"./schememaster";
import worktypemaster from"./worktypemaster";
import schemebeneficiarymaster from"./schemebeneficiarymaster";
import deptbeneficiarymaster from"./deptbeneficiarymaster";
import beneficiary from"./beneficiary";
import boothassignment from"./boothassignment";
import voterdistribution from"./voterdistribution";
import reporting from"./reporting";
import dataoperatorliveele from"./dataoperatorliveele";
import volunteerliveele from"./volunteerliveele";
import adminliveele from"./adminliveele";
import subadminlive from "./subadminlive";
import subadminlive2 from "./subadminlive2";

export default{
    voter,
    nonvoter,
    development,
    schememaster,
    worktypemaster,
    schemebeneficiarymaster,
    deptbeneficiarymaster,
    beneficiary,
    boothassignment,
    voterdistribution,
    reporting,
    dataoperatorliveele,
    volunteerliveele,
    adminliveele,
    subadminlive,
    subadminlive2,
...Masters,
    
};